var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { convertUnit } from "../../../common";
import { autoCropCanvas } from "./autoCropCanvas";
export default function addCanvasToPdfPage(pdfDoc, canvas, mediaSize, autoCrop = false) {
    return __awaiter(this, void 0, void 0, function* () {
        let w = convertUnit("600dpi", canvas.width, "pt");
        let h = convertUnit("600dpi", canvas.height, "pt");
        const paperWidth_pt = convertUnit(mediaSize.unit, mediaSize.width, "pt");
        const paperHeight_pt = convertUnit(mediaSize.unit, mediaSize.height, "pt");
        let pw = paperWidth_pt;
        let ph = paperHeight_pt;
        const x = 0;
        const y = 0;
        if (autoCrop) {
            const ret = autoCropCanvas({
                imgSize: { unit: "600dpi", name: "POD", width: canvas.width, height: canvas.height },
                canvas
            });
            const { croppedCanvas, croppedPageSize } = ret;
            canvas = croppedCanvas;
            w = convertUnit("600dpi", canvas.width, "pt");
            h = convertUnit("600dpi", canvas.height, "pt");
            pw = w;
            ph = h;
        }
        const pngUrl = canvas.toDataURL("image/png", 1.0);
        const pngImage = yield pdfDoc.embedPng(pngUrl);
        // const page = pdfDoc.addPage(PageSizes.A7);
        const page = pdfDoc.addPage([pw, ph]);
        page.drawImage(pngImage, {
            x,
            y,
            width: w,
            height: h,
            opacity: 1,
        });
    });
}
export function addPdfPage(pdfDoc, canvas, dpi) {
    const w = convertUnit("600dpi", canvas.width, "pt") * 600 / dpi;
    const h = convertUnit("600dpi", canvas.height, "pt") * 600 / dpi;
    const page = pdfDoc.addPage([w, h]);
    return page;
}
export function addCanvasToPdfPage2(pdfDoc, page, canvas, dpi, nTimes) {
    return __awaiter(this, void 0, void 0, function* () {
        const w = convertUnit("600dpi", canvas.width, "pt") * 600 / dpi;
        const h = convertUnit("600dpi", canvas.height, "pt") * 600 / dpi;
        const x = 0;
        const y = 0;
        const pngUrl = canvas.toDataURL("image/png", 1.0);
        const pngImage = yield pdfDoc.embedPng(pngUrl);
        // const page = pdfDoc.addPage(PageSizes.A7);
        for (let i = 0; i < nTimes; i++) {
            page.drawImage(pngImage, { x, y, width: w, height: h, opacity: 1, });
        }
    });
}
//# sourceMappingURL=addCanvasToPdfPage.js.map